import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';
import { handleExport } from '../utils/exportUtils';
import ExportSelect from '../Class/ExportType';

const OverAllStudentList = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [exportFormat, setExportFormat] = useState('');

  useEffect(() => {
   
console.log("Logged in as:", user?.name);
    fetchStudentData();
  }, [user]);

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.OverAllStudentDetails);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayClick = async (row) => {
    const feeType = row.ADDFEES;
    const className = row.CLASS;
    const type = 'N';
    const AdmissionID=row.STUDENT_ID

    if (!feeType || !className) {
      alert('Missing class or fee type for this student.');
      return;
    }

    //const url = `https://school.agnisofterp.com/agni/fees/list?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}`;
    const url = AppStrings.FeesDetailGet+`?TYPE=${type}&CLASS=${className}&FEESTYPE=${feeType}&ADMISSIONID=${AdmissionID}`;

    try {
      const response = await axios.get(url);
      const result = response.data.data.result || response.data.data;

      if (Array.isArray(result)) {
        const withEditable = result.map(item => ({ ...item, current: '', discount: '' }));
        setSelectedRow(row);
        setFeeDetails(withEditable);
      } else {
        alert(`No fee records found for ${row.NAME}`);
        setFeeDetails([]);
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      alert("Failed to fetch fee details.");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);


  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");
        
    const handleSubmit = async () => {
      const payload = {
        student: {
          id: selectedRow.STUDENT_ID,
          admissionDate: admissionDate,
          type: selectedRow.ADDFEES,
        },
        fees: feeDetails .filter(({ current, discount }) => {
          const paid = parseFloat(current) || 0;
          const off = parseFloat(discount) || 0;
          return paid + off > 0;
        }).map(({ TYPE, FEES,current, discount }) => ({
          TYPE,
          FEES,
          current,
          discount
        }))
      };
  
      try {
        console.log('haiiii');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StudentFeesEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
       // console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
        fetchStudentData();
       // console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

    const handleExportClick = () => {
      handleExport(data, exportFormat, 'Student_Bus_Fees');
    };

  return (
    <div style={{ padding: '0px' }}>
      <h2>Over All Student List</h2>

      {loading && <p>Loading data...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <input
              type="text"
              placeholder="Search By Student Name/Student Id"
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
        </div>
        <div className="col-75">
        
          
        <div className="row">
        <div className="col-25 colM">
        <ExportSelect
      value={exportFormat} // Controlled value for the select dropdown
      onChange={(e) => setExportFormat(e.target.value)} // Handle change to update formData
    />
    
    </div>
    <div className="col-75 colM ">
    <button className='GridButton' onClick={handleExportClick} disabled={!exportFormat}>
  Export
</button>
    
    </div>
    </div>
      </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: '440px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>Student ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Class-Sec</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Phone</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Class</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Type</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Tuition Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Transport Due</th>
                <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
                    <td style={cellStyle}>{row.CLASS_SEC}</td>
                    <td style={cellStyle}>{row.PHONE}</td>
                    <td style={cellStyle}>{row.CLASS}</td>
                    <td style={cellStyle}>{row.ADDFEES}</td>
                    <td style={cellStyle}>{row.TUITION_DUE}</td>
                    <td style={cellStyle}>{row.TRANSPORT_DUE}</td>
                    <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={handleCancel}>Cancel</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedRow && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <h3>{selectedRow.STUDENT_ID+'-'+selectedRow.NAME+'-'+selectedRow.CLASS}</h3>
            <div style={{ marginTop: '15px', textAlign: 'left', fontWeight: 'bold', fontSize: '16px' }}>
            <div className="row">
        <div className="col-25">
        <div className="col-25">
        
            <div className="coolinput">
          {/* <label for="input" class="text">Admission Date:</label> */}
            <input
              required
              type="date"
              name="DOADM"
              autoComplete="off"
              className="input"
              value={admissionDate}
              onChange={(e) => setAdmissionDate(e.target.value)}
            />
            
            </div> 
          </div> 
          </div>
          </div>
                </div>
            {feeDetails.length > 0 ? (
              <table style={{ width: '100%', marginTop: '10px',overflowY: 'auto', border: '1px solid #ccc',borderCollapse: 'collapse',   tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={headerCellStyle}>Fee Type</th>
                    <th style={headerCellStyle}>Fee Amount</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Paid</th>
                  </tr>
                </thead>
                <tbody>
                  {feeDetails.map((fee, idx) => {
                    const feeAmount = parseFloat(fee.FEES) || 0;
                    const discount = parseFloat(fee.discount) || 0;
                    const payable = feeAmount - discount;

                    return (
                      <tr key={idx}>
                        <td style={cellStyle}>{fee.TYPE}</td>
                        <td style={cellStyle}>{fee.FEES}</td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Discount"
                            value={fee.discount}
                            onChange={(e) => handleInputChange(idx, 'discount', e.target.value)}
                            className="input"
                          />
                          </div>
                        </td>
                        <td style={cellStyle}>
                        <div class="coolinput">
                          <input
                            type="text"
                            placeholder="Enter Paid Amount"
                            value={fee.current}
                            onChange={(e) => handleInputChange(idx, 'current', e.target.value)}
                            className="input"
                          />
                          </div>
                          <div style={{ fontSize: '0.8em', color: '#555' }}>
                            Payable: ₹{payable.toFixed(2)}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            
            ) : (
              <p>No fee data available.</p>
            )}
             <div style={{ marginTop: '15px', textAlign: 'right', fontWeight: 'bold', fontSize: '16px' }}>
                  Total Paid Amount: ₹{totalPaid.toFixed(2)}
                </div>
                <button onClick={handleSubmit} style={{ marginTop: '15px' }}>Save</button>
            <button onClick={handleCancel} style={{ marginTop: '15px' }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const headerCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '700px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};

export default OverAllStudentList;
